import { callApi } from 'services/api/api'
import { toastStore } from 'stores/toast'
import { TOAST_TYPE } from 'utils/constants'
import { baseURL, isLocalEnv } from 'services/api/apiConfig'
import { appSelected } from 'stores/navigation'

let selectedApplication = 'physician'
appSelected.subscribe(value => {
  if (value.toLocaleLowerCase() === 'app') {
    selectedApplication = 'app'
  } else {
    selectedApplication = 'physician'
  }
})

export const getSubmissionSpecialtyGroups = async (submissionId, section) => {
  try {
    let url = `${baseURL}/market-positioning/${selectedApplication}/specialty-groups`
    const response = await callApi(url, 'POST', { submissionId, section })
    return response
  } catch (error) {
    toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'Error retrieving  specialty groups. Please try again later.')
    return []
  }
}

export const getSubmissionSpecialties = async (submissionId, section, specialtyGroupNames = []) => {
  try {
    let url = `${baseURL}/market-positioning/${selectedApplication}/specialties`
    const response = await callApi(url, 'POST', { submissionId, section, specialtyGroupNames })
    return response
  } catch (error) {
    toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'Error retrieving  specialty groups. Please try again later.')
    return []
  }
}

export const getSubmissionIncumbentIdentifiers = async (submissionId, section) => {
  try {
    let url = `${baseURL}/market-positioning/${selectedApplication}/incumbent-identifiers`
    const response = await callApi(url, 'POST', { submissionId, section })
    return response
  } catch (error) {
    toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'Error retrieving Incumbent Identifiers list. Please try again later.')
    return []
  }
}

export const getIncumbentScatterplot = async payload => {
  try {
    const url = `${baseURL}/market-positioning/${selectedApplication}/scatterplot`
    const response = await callApi(url, 'POST', payload)
    return response
  } catch (error) {
    toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'Error retrieving incumbent scatterplot data.')
    console.error(error)
    return []
  }
}

export const getIncumbentScatterplotByOppAssessment = async payload => {
  try {
    const url = `${baseURL}/market-positioning/${selectedApplication}/scatterplot-by-opportunity-assessment`
    const response = await callApi(url, 'POST', payload)
    return response
  } catch (error) {
    toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'Error retrieving incumbent opportunity assessment data.')
    console.error(error)
    return []
  }
}

export const getSpecialtyScatterplot = async payload => {
  try {
    const url = `${baseURL}/market-positioning/standard-job/${selectedApplication}/scatterplot`
    const response = await callApi(url, 'POST', payload)
    return response
  } catch (error) {
    toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'Error retrieving specialty scatterplot data.')
    console.error(error)
    return []
  }
}

export const getSpecialtyScatterplotByOppAssessment = async payload => {
  try {
    const url = `${baseURL}/market-positioning/standard-job/${selectedApplication}/scatterplot-by-opportunity-assessment`
    const response = await callApi(url, 'POST', payload)
    return response
  } catch (error) {
    toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'Error retrieving specialty opportunity assessment data.')
    console.error(error)
    return []
  }
}

export const getSpecialtyGroupBarChart = async payload => {
  try {
    const url = `${baseURL}/market-positioning/standard-job-group/${selectedApplication}/barchart`
    const response = await callApi(url, 'POST', payload)
    return response
  } catch (error) {
    toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'Error retrieving specialty group barchart data.')
    console.error(error)
    return []
  }
}

export const getMarketPositioningIncumbentData = async payload => {
  try {
    const response = await callApi(`${baseURL}/market-positioning/${selectedApplication}/grid`, 'POST', payload)
    return response
  } catch (error) {
    if (isLocalEnv) {
      toastStore.createToast(TOAST_TYPE.ERROR, 'Mocked data', 'We are mocking data for getMarketPositioningIncumbentData')
      return []
    } else {
      toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'Error getting market positioning incumbent ')
      console.error(error)
    }
  }
}

/**
 * getMarketPositioningIncumbentDataHeader
 * payload: {
 *   "cutKey": 0,
 *   "section": "string",
 *   "submissionId": 0,
 *   "surveyKey": 0
 * }
 */
export const getMarketPositioningIncumbentDataHeader = async payload => {
  try {
    const response = await callApi(`${baseURL}/market-positioning/${selectedApplication}/header`, 'POST', payload)
    return response
  } catch (error) {
    toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'Error getting market positioning incumbent header')
    console.error(error)
    return {}
  }
}

export const getMarketPositioningSpecialtyData = async payload => {
  try {
    const response = await callApi(`${baseURL}/market-positioning/standard-job/${selectedApplication}/grid`, 'POST', payload)
    return response
  } catch (error) {
    if (isLocalEnv) {
      toastStore.createToast(TOAST_TYPE.ERROR, 'Mocked data', 'We are mocking data for getMarketPositioningSpecialtyData')
      return []
    } else {
      toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'Error getting market positioning specialty')
      console.error(error)
    }
  }
}

export const getMarketPositioningSpecialtyGroupData = async payload => {
  try {
    const response = await callApi(`${baseURL}/market-positioning/standard-job-group/${selectedApplication}/grid`, 'POST', payload)
    return response
  } catch (error) {
    if (isLocalEnv) {
      toastStore.createToast(TOAST_TYPE.ERROR, 'Mocked data', 'We are mocking data for getMarketPositioningSpecialtyGroupData')
      return []
    } else {
      toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'Error getting market positioning specialty group ')
      console.error(error)
    }
  }
}

export const postMarketPositioningExport = async payload => {
  try {
    return await callApi(`${baseURL}/market-positioning/${selectedApplication}/export`, 'POST', payload)
  } catch (error) {
    toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'Error exporting Market Positioning data')
    throw error
  }
}

export const postMarketPositioningSpecialtyExport = async payload => {
  try {
    return await callApi(`${baseURL}/market-positioning/standard-job/${selectedApplication}/export`, 'POST', payload)
  } catch (error) {
    toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'Error exporting Market Positioning data')
    throw error
  }
}

export const postMarketPositioningSpecialtyGroupExport = async payload => {
  try {
    return await callApi(`${baseURL}/market-positioning/standard-job-group/${selectedApplication}/export`, 'POST', payload)
  } catch (error) {
    toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'Error exporting Market Positioning specialty group data')
    throw error
  }
}

export async function getIncumbentMarketPositioningFilter(body) {
  try {
    return await callApi(`${baseURL}/v2/market-positioning/${selectedApplication}/filters`, 'POST', body)
  } catch (error) {
    toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'Error getting filters for market positioning')
    throw error
  }
}

export async function getSpecialtyMarketPositioningFilter(body) {
  try {
    return await callApi(`${baseURL}/market-positioning/standard-job/${selectedApplication}/filters`, 'POST', body)
  } catch (error) {
    toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'Error getting filters for market positioning')
    throw error
  }
}

export async function getSpecialtyGroupMarketPositioningFilter(body) {
  try {
    return await callApi(`${baseURL}/market-positioning/standard-job-group/${selectedApplication}/filters`, 'POST', body)
  } catch (error) {
    toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'Error getting filters for market positioning')
    throw error
  }
}

export async function getOpportunityAssessmentMarketPositioningFilter() {
  try {
    return await callApi(`${baseURL}/market-positioning/${selectedApplication}/opportunities-assessment `, 'GET')
  } catch (error) {
    toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'Error getting filters for market positioning')
    throw error
  }
}
